// Only explicitly abbreviated years belong to this century. Preserve 1926, etc.
export function normalizeDialogDate(value) {
  if (typeof value === "string") return value.replace(/^00(\d{2})(?=-\d{2}-\d{2}$)/, "20$1");
  if (value?.isValid?.() && value.year() >= 0 && value.year() < 100) return value.year(2000 + value.year());
  return value;
}
